import { useState } from 'react';

import { reports } from '../api/endpoints.ts';
import { errorText, useStrings } from '../i18n/index.ts';
import { notify } from '../state/toasts.ts';
import { Icon } from '../ui/icons.tsx';
import { Button, cx, ErrorBanner, GlassButton, ScreenTitle } from '../ui/kit.tsx';
import { Sheet } from '../ui/Sheet.tsx';

const REASONS = ['wrong_info', 'quality', 'missing', 'other'] as const;

/** Жалоба на товар или заказ: причина из списка и комментарий. */
export function ReportSheet(props: { productId?: string; orderId?: string; onClose: () => void }) {
  const strings = useStrings();
  const [reason, setReason] = useState<string>(REASONS[0]);
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const send = (close: () => void) => {
    setSending(true);
    setError(null);
    reports
      .create({
        ...(props.productId ? { productId: props.productId } : {}),
        ...(props.orderId ? { orderId: props.orderId } : {}),
        reason,
        text: text.trim() || undefined,
      })
      .then(() => {
        notify(strings.reportSent);
        close();
      })
      .catch((cause: unknown) => setError(errorText(strings, cause)))
      .finally(() => setSending(false));
  };

  return (
    <Sheet onClose={props.onClose} size="medium" label={strings.report}>
      {(close) => (
        <div className="sheet-body">
          <div className="sheet-header">
            <GlassButton icon="close" label={strings.cancel} onClick={close} />
          </div>
          <div className="stack sheet-pad" style={{ gap: 18, paddingTop: 4 }}>
            <div style={{ marginInline: 'calc(var(--gutter) * -1)' }}>
              <ScreenTitle text={strings.report} />
            </div>
            <div className="card flush" role="radiogroup">
              {REASONS.map((code) => (
                <button key={code} type="button" role="radio" aria-checked={reason === code} className="list-row" onClick={() => setReason(code)}>
                  <span className="grow" style={{ fontSize: 17 }}>
                    {strings.reportReason(code)}
                  </span>
                  <span className={cx('radio-mark', reason === code && 'is-on')}>{reason === code && <Icon name="check" size={13} weight={3.4} />}</span>
                </button>
              ))}
            </div>
            <textarea
              className="card plain-input report-text"
              rows={3}
              placeholder={strings.reportPlaceholder}
              value={text}
              onChange={(event) => setText(event.target.value)}
            />
            {error && <ErrorBanner text={error} />}
            <Button busy={sending} onClick={() => send(close)}>
              {strings.reportSend}
            </Button>
          </div>
        </div>
      )}
    </Sheet>
  );
}
